import React from 'react';
import AccountActivation from 'cccisd-laravel-appdefs/node_modules/cccisd-table-renders/dist/renderers/html/AccountActivation';

/*
 *   Wraps the careCoordinator's "Account Activation" column cell
 *   so that the invite button only appears when the enrolledInSmartwrap field is true
 */
export default settings => {
    const renderAccountActivation = AccountActivation(settings);

    return props => {
        if (!props.row['fields.enrolledInSmartwrap']) {
            return <span>-</span>;
        }

        return renderAccountActivation(props);
    };
};
